export const Regions = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="10" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="5" width="8" height="10" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="5" y="15" width="10" height="12" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M23 18V28" stroke="currentColor" stroke-width="2"/>
<path d="M28 23L18 23" stroke="currentColor" stroke-width="2"/>
</svg>`;
